import React from 'react';
import { Sheet } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import LoginPopup from './loginPopup';

const LoginPopupSheet = ({
  isSheetOpen,
  closeSheet,
  orgName,
  showSignup = false,
  onBeforeCloseSheet,
}) => {
  return (
    <Sheet
      title="login-popup-sheet"
      hideTitle={true}
      className="login-popup-sheet"
      isOpen={isSheetOpen}
      onClose={closeSheet}
      onBeforeClose={onBeforeCloseSheet}
      mobileFixedHeight="90"
    >
      <LoginPopup showSignup={showSignup} orgName={orgName} />
    </Sheet>
  );
};

LoginPopupSheet.propTypes = {
  isSheetOpen: PropTypes.bool,
  closeSheet: PropTypes.func,
  orgName: PropTypes.string,
  showSignup: PropTypes.bool,
  onBeforeCloseSheet: PropTypes.func,
};

export default LoginPopupSheet;
